module.exports = __webpack_public_path__ + "static/FooterLogoMobile.9313d05d.svg";